export default "/images/dv-curved.svg?846dd6917c7d300ce711304287434591";